/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateSettingsWorkplaceLocationApiArg, WorkplaceLocationData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSettingsWorkplaceLocation: build.mutation<WorkplaceLocationData, UpdateSettingsWorkplaceLocationApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/settings/workplace/location`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateSettingsWorkplaceLocationApi };
export const { useUpdateSettingsWorkplaceLocationMutation } = injectedRtkApi;
